module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921050834_T.5db91c07.jpg";